<template>
  <div class="new">
    <van-nav-bar title="明细" left-arrow @click-left="onClickLeft" />
    <div class="imgArr" v-for="(item,index) in images" :key="index">
          <img :src="item" style="width:100%">
        </div>
  </div>
</template>
<script>
import { NavBar, Icon, loading } from "vant";
import axios from "axios";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [loading.name]: loading,
  },
  data() {
    return {
      images: [],
    };
  },
  mounted() {
    var id = this.$route.query.id;
    var idx = this.$route.query.index;
    let that = this;
    axios
      .post("https://mqzpower.ncscloudmedia.com/index.php/api/article/detail", {
        article_id: id,
      })
      .then(function (response) {
        let res = response.data;
        if (res.code == 1) {
          that.images = res.data.tables[idx].images;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/infoNew.vue